import type { PayloadAction } from "@reduxjs/toolkit";

import type { IActiveQuery } from "./models";

export const UPDATE = "activeQuery/update";
export function updatePriceMode(
  payload: IActiveQuery,
): PayloadAction<IActiveQuery> {
  return {
    type: UPDATE,
    payload,
  };
}

export const CLEAR = "activeQuery/clear";
export function clearActiveQuery(): PayloadAction<null> {
  return {
    type: CLEAR,
    payload: null,
  };
}
